import { render } from "./MakeReview.vue?vue&type=template&id=4ae4514a&scoped=true"
import script from "./MakeReview.vue?vue&type=script&lang=js"
export * from "./MakeReview.vue?vue&type=script&lang=js"

import "./MakeReview.vue?vue&type=style&index=0&id=4ae4514a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae4514a"]])

export default __exports__